<template>
<section class="ofp-chart-wrapper" :style="{
  height: `${Math.max(400, ((topNumber | 0) * 25) + 85)}px`
}">
  <div class="ofp-chart-container">
    <e-chart
      ref="ofp-chart"
      @initialized="onOFPChartInitialized"
      @destroy="onOFPChartDestroy"
    />
  </div>
  <div class="iofp-chart-container">
    <e-chart ref="iofp-chart" />
  </div>
</section>
</template>

<script>
import {AXIS_LABEL, AXIS_LINE_STYLE, TEXT_FONT_FAMILY} from './FactorCharts/chartStyle'
import BaseStore from '../BaseStore'

export default {
  name: 'OFPChart',
  extends: BaseStore,
  props: {
    data: {
      required: true,
      type: Object
    },
    isAuditCompleted: {
      type: Boolean
    },
    unit: {
      required: true,
      type: String
    },
    topNumber: {
      required: true,
      type: Number
    }
  },
  methods: {
    render () {
      let {data} = this
      this.renderOFPChart(data)
      let findData = data.data.find(data => Number.isFinite(data.value))
      findData ? this.renderIOFPChart(findData) : this.$refs['iofp-chart'].clear()
    },
    renderOFPChart (data) {
      let dataList = data.data
      let dataListLen = dataList.length
      let dataZoomStart = dataListLen <= 72 ? 0 : ((dataListLen - 72) / dataListLen * 100).toFixed(0)
      let chartOpt = {
        title: {
          text: data.name,
          left: 'center',
          textStyle: {
            fontFamily: TEXT_FONT_FAMILY
          }
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 23
        },
        tooltip: {},
        grid: [{
          top: 40,
          right: 40,
          bottom: 45,
          left: 30,
          containLabel: true
        }],
        xAxis: [{
          type: 'category',
          data: dataList.map(data => data.dataTime),
          axisLine: {
            show: true,
            lineStyle: AXIS_LINE_STYLE
          },
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: TEXT_FONT_FAMILY,
            formatter: date => new Date(date).format('MM月DD日HH时')
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          }
        }],
        yAxis: {
          type: 'value',
          name: this.unit,
          axisLine: {
            show: false
            // lineStyle: AXIS_LINE_STYLE
          },
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: TEXT_FONT_FAMILY
          }
        },
        dataZoom: [{
          type: 'inside',
          start: dataZoomStart,
          end: 100,
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5
        }, {
          type: 'slider',
          start: dataZoomStart,
          end: 100,
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5,
          // height: 39,
          bottom: 9,
          left: 'center',
          handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
          handleSize: '70%',
          handleStyle: {
            color: '#fff',
            shadowBlur: 4,
            shadowColor: 'rgba(0, 0, 0, 0.15)',
            shadowOffsetX: 2,
            shadowOffsetY: 2
          },
          // dataBackground: {
          //   areaStyle: '#E4F0FF'
          // }
          fillerColor: 'rgba(228, 240, 255, .6)',
          borderColor: '#E4F0FF'
        }],
        series: [{
          name: 'OFP',
          type: 'bar',
          barMaxWidth: 30,
          data: dataList,
          color: '#3ba272'
        }]
      }

      this.$refs['ofp-chart'].setOpt(chartOpt)
    },
    renderIOFPChart (selectedData) {
      let {iofps} = selectedData
      let chartOpt = {
        title: {
          text: selectedData.title || new Date(selectedData.dataTime).format('YYYY-MM-DD HH'),
          left: 'center',
          textStyle: {
            fontFamily: TEXT_FONT_FAMILY
          }
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 23
        },
        tooltip: {},
        grid: [{
          top: 40,
          right: 40,
          bottom: 45,
          left: 0,
          containLabel: true
        }],
        xAxis: [{
          type: 'value',
          name: this.unit,
          nameLocation: 'center',
          nameGap: 23,
          axisLine: {
            show: false
          },
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: TEXT_FONT_FAMILY
          },
          axisTick: {
            show: false,
            alignWithLabel: true
          }
        }],
        yAxis: {
          type: 'category',
          data: iofps.map(iofp => iofp.name),
          inverse: true,
          axisLine: {
            show: true
            // lineStyle: AXIS_LINE_STYLE
          },
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: TEXT_FONT_FAMILY
          }
        },
        series: [{
          name: 'iofp',
          type: 'bar',
          barMaxWidth: 30,
          data: iofps.map(iofp => iofp.value),
          color: '#9a60b4'
        }]
      }

      this.$refs['iofp-chart'].setOpt(chartOpt)
      selectedData.title = null
    },
    onOFPChartClick (param) {
      let {dataTime, value} = param.data

      this.changeLoadStatus(true)
      this.$api.Data.getStatisticAnalysisVOCsIOFP(this.data.id, {
        dataTime,
        isAuditCompleted: this.isAuditCompleted,
        unit: this.unit
      }).then(dataList => {
        let {factorMap} = this
        this.renderIOFPChart({
          dataTime,
          value,
          iofps: dataList.map(({factorId, iofp}) => ({
            id: factorId,
            name: factorMap[factorId].name,
            value: iofp
          }))
        })
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    onOFPChartInitialized (chart) {
      chart.on('click', this.onOFPChartClick)
    },
    onOFPChartDestroy (chart) {
      chart.off('click', this.onOFPChartClick)
    }
  },
  watch: {
    topNumber () {
      setTimeout(() => {
        this.$refs['ofp-chart'].resize()
        this.$refs['iofp-chart'].resize()
      }, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.ofp-chart-wrapper {
  width: 100%;
  min-height: 400px;

  &:after {
    content: "";
    clear: both;
  }

  > .ofp-chart-container,
  > .iofp-chart-container {
    float: left;
    height: 100%;
  }

  > .ofp-chart-container {
    width: 62%;
  }

  > .iofp-chart-container {
    width: 38%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Data/OFPChart.vue